// Portuguese translations (Português)
import type { TranslationKeys } from './en';

export const pt: TranslationKeys = {
  // Common
  common: {
    home: 'Início',
    settings: 'Configurações',
    language: 'Idioma',
    loading: 'Carregando...',
    save: 'Salvar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    close: 'Fechar',
    back: 'Back',
    continue: 'Continue',
    accept: 'Accept',
    decline: 'Decline',
    contactEmail: 'contact@zodiac-chess.com',
    companyName: 'Animal Chess Limited',
    companyCountry: 'New Zealand',
  },

  // Settings Menu
  settings: {
    header: 'Configurações',
    home: 'Início',
    howToPlay: 'Como Jogar',
    pieceRules: 'Regras das Peças',
    language: 'Idioma',
    manageSubscription: 'Gerenciar Assinatura',
    gameHistory: 'Histórico de Jogos',
    analytics: 'Análises',
    premiumAccount: 'Conta Premium',
    chatEnabled: 'Chat: Ativado',
    chatDisabled: 'Chat: Desativado',
  },

  // Piece Rules
  pieceRules: {
    title: 'Regras das Peças',
    description: 'Aprenda o movimento das peças',
    selectPiece: 'Selecionar Peça',
    selectedLabel: 'Selecionado:',
    statusLabel: 'Status:',
    statusReady: 'Pronto',
    statusViewing: 'Visualizando',
    movement: 'Movimento',
    regularMovement: 'Movimento Regular',
    ability: 'Habilidade',
      backToSelection: 'Back to selection',
    backToHome: 'Back to home',
  },

  // Move/Ability Names
  moves: {
    movement: 'Movimento',
    savage: 'Selvagem',
    birdtype: 'Tipo Pássaro',
    birdType: 'Tipo Pássaro',
    wallBlock: 'Bloqueio de Parede',
    moveblocks: 'Bloqueios de Movimento',
    wallclimb: 'Escalada de Parede',
    lilypad: 'Vitória-régia',
    poisonous: 'Venenoso',
    meadow: 'Prado',
    parasiticfungi: 'Fungo Parasita',
    zombification: 'Zumbificação',
    fungi: 'Fungo',
    traverse: 'Atravessar',
    capture: 'Capturar',
    faint: 'Desmaiar',
    leap: 'Saltar',
    swing: 'Balançar',
    consume: 'Consumir',
    gamble: 'Apostar',
    entangle: 'Enredar',
    ink: 'Tinta',
    rotate: 'Girar',
    backstep: 'Passo Atrás',
    trample: 'Pisotear',
    charge: 'Investida',
    lane: 'Faixa',
    snakestrike: 'Ataque de Cobra',
    shedskin: 'Troca de Pele',
    house: 'Casa',
    plant: 'Tipo Planta',
    planttype: 'Tipo Planta',
    capturehost: 'Capturar Hospedeiro',
    contagion: 'Contágio',
    lonewolf: 'Lobo Solitário',
    hop: 'Pulo',
    decay: 'Deterioração',
    slide: 'Deslizar',
    block: 'Bloquear',
    poison: 'Veneno',
    infection: 'Infecção',
    howl: 'Uivo',
  },

  // Animation Scenario Descriptions
  scenarios: {
    // Bear
    bearMovement: 'O Urso pode mover uma casa em qualquer direção, como um rei no xadrez',
    bearMovementPost: 'Ele só é bloqueado por peças amigas (exceto Árvores, Ursos podem escalar Árvores!)',
    bearSavage: 'Um Urso pode superar habilidades defensivas como o Bloqueio do Rinoceronte',
    bearSavagePost: 'Usando Selvagem o Urso pode capturar qualquer peça de qualquer direção, adicionando letalidade',

    // Crane
    craneMovement: 'O Grou pode mover 1 ou 2 casas em qualquer linha reta',
    craneMovementPost: 'O Grou pode até voar sobre outras peças!',
    craneBirdType: 'Peças do tipo pássaro não podem capturar peças grandes ou predadoras',
    craneBirdTypePost: 'Isso inclui Árvore, Rinoceronte, Urso e Lobo',

    // Frog
    frogMovement: 'O Sapo salta 2 casas diagonalmente',
    frogMovementPost: 'Ele não pode pular apenas uma',
    frogWallBlock: 'Se o caminho regular de 2 casas do Sapo for bloqueado por uma parede ou outra peça, ele não pode capturar',
    frogWallBlockPost: 'Seu movimento regular é encurtado para 1 casa diagonalmente',
    frogWallClimb: 'Quando o Sapo está na parede do tabuleiro (Coluna A ou E) ele pode mover para cima ou para baixo uma casa',
    frogWallClimbPost: 'A menos que bloqueado por uma peça amiga ou um Rinoceronte na frente do Sapo',
    frogLilypad: 'Se o Sapo ainda não se moveu em um jogo, ele pode mover para qualquer uma das 3 primeiras fileiras como uma poderosa habilidade defensiva',
    frogLilypadPost: 'Ele pode capturar qualquer peça regular usando Salto de Vitória-régia, exceto um Rinoceronte em uma fileira superior',
    frogPoisonous: 'Quando qualquer animal captura uma peça de Sapo, você fica envenenado!',
    frogPoisonousPost: 'Uma peça envenenada pula seu próximo turno disponível antes de se recuperar',

    // Fungi
    fungiMovement: 'O Fungo pode mover uma casa em qualquer direção',
    fungiMovementPost: 'Ele só é bloqueado por peças aliadas',
    fungiMeadow: 'O Fungo reduz a habilidade de movimento da peça de Árvore inimiga',
    fungiMeadowPost: 'A peça de Árvore inimiga não pode se mover dentro de 1 casa da peça de Fungo',
    fungiParasitic: 'O Fungo pode imobilizar a peça de Árvore inimiga',
    fungiParasiticPost: 'Se o Fungo estiver dentro de 1 casa da Árvore inimiga, ela não pode se mover até que o Fungo se afaste ou seja capturado',
    fungiZombification: 'O Fungo pode zumbificar qualquer peça animal inimiga que o capture, permitindo controle sobre o animal inimigo por um turno',
    fungiZombificationPost: 'A peça zumbificada também é considerada a peça de Fungo para aquele turno, mesmo se o Fungo fosse seu rei o jogo não termina até depois daquele turno',
    fungiFungi: 'Cogumelo',
    fungiFungiPost: 'Como veneno, enredamento e infecção por vírus, mas não zumbificação, pois pode zumbificar outros!',

    // Goat
    goatMovement: 'A Cabra pode mover uma casa em qualquer direção',
    goatMovementPost: 'A Cabra se move lentamente mas tem habilidades poderosas',
    goatTraverse: 'A Cabra pode atravessar por cima de quaisquer outras peças conectadas para criar potencial de movimento massivo',
    goatTraversePost: 'A Cabra não pode atravessar sobre Cabras Desmaiadas ou peças Pequenas como Vírus',
    goatCapture: 'A Cabra não pode capturar nenhum Predador',
    goatCapturePost: 'Como Urso ou Lobo',
    goatFaint: 'A Cabra pode desmaiar para evitar captura exceto de peças grandes como a Árvore e Rinoceronte',
    goatFaintPost: 'Enquanto desmaiada, os oponentes podem "ficar" sobre a cabra desmaiada para parar seu movimento',

    // Monkey
    monkeyMovement: 'O Macaco pode mover uma casa em qualquer direção',
    monkeyMovementPost: 'Sem outras peças para utilizar, o Macaco tem movimento limitado',
    monkeyLeap: 'O Macaco, como um jogo de damas, pode saltar sobre outras peças em linha reta para enorme potencial de movimento',
    monkeyLeapPost: 'Mas se saltar sobre uma peça inimiga, o Macaco deve rolar um dado para sobreviver ao salto, 1/6 de chance de captura para cada inimigo que ele salta!',
    monkeySwing: 'Se um Macaco usa um salto sobre uma Árvore, o Macaco ganha um turno bônus',
    monkeySwingPost: 'Usar balanço de árvore cria um combo sinérgico poderoso entre as peças de Macaco e Árvore',
    monkeyConsume: 'O Macaco pode consumir uma peça de Fungo para um turno bônus',
    monkeyConsumePost: 'Levando a combinações devastadoras quando combinado com outros turnos bônus',
    monkeyGamble: 'Além de rolar um dado para saltar sobre inimigos, o Macaco deve apostar para capturar o Urso',
    monkeyGamblePost: 'O macaco deve rolar um 5 ou um 6 em um dado de 6 lados para capturar o Urso ou é capturado',

    // Octopus
    octopusMovement: 'O Polvo se move uma casa em qualquer direção',
    octopusCapture: 'O Polvo só pode capturar ortogonalmente',
    octopusCapturePost: 'O polvo pode capturar ou enredar peças de formas complexas, então sempre verifique capturas vermelhas e enredamentos roxos!',
    octopusEntangle: 'O Polvo pode enredar peças inimigas adjacentes, imobilizando-as, ele pode até mover uma casa e enredar inimigos!',
    octopusEntanglePost: 'Peças enredadas não podem se mover até que o Polvo se afaste ou seja capturado',
    octopusInk: 'O Polvo pode usar tinta para escapar de situações perigosas, criando até 3 sombras',
    octopusInkPost: 'Confundindo o inimigo e permitindo jogadas interessantes de isca e evasão',

    // Penguin
    penguinMovement: 'O Pinguim desliza em linha reta em sua direção definida até que uma parede ou peça bloqueie seu movimento',
    penguinMovementPost: 'Após mover, o Pinguim dentro do mesmo turno pode definir sua direção final também',
    penguinRotate: 'No início da partida um Pinguim está virado para baixo e deve girar antes de poder deslizar, também conhecido como dormindo',
    penguinRotatePost: 'O pinguim em qualquer posição pode escolher girar ao invés de se mover',
    penguinBirdType: 'O Pinguim tem habilidades de captura limitadas, como o Grou, ele não pode capturar peças grandes ou predadoras como a Árvore, Rinoceronte, Urso ou Lobo',
    penguinBirdTypePost: 'Após capturar, o Pinguim pode girar para qualquer direção para posicionamento estratégico',

    // Rhino
    rhinoMovement: 'O Rinoceronte move duas casas apenas para frente',
    rhinoMovementPost: 'Ele não pode mover apenas 1 casa',
    rhinoBackStep: 'O Rinoceronte pode mover para trás-esquerda ou trás-direita',
    rhinoCharge: 'O Rinoceronte uma vez por jogo pode viajar uma casa extra para frente usando sua habilidade de investida',
    rhinoChargePost: 'Levando a potencial de movimento e captura devastadores',
    rhinoTrample: 'O Rinoceronte captura todas as peças em seu caminho de viagem com Pisotear',
    rhinoTramplePost: 'Incluindo uma peça de Cabra desmaiada',
    rhinoLane: 'O Rinoceronte pode trocar de lugar com outra peça aliada permitindo jogada estratégica de faixa',
    rhinoLanePost: 'Mas apenas se o Rinoceronte e a peça Aliada não tenham se movido',

    // Snake
    snakeMovement: 'A Cobra pode mover 2 casas em qualquer linha reta',
    snakeMovementPost: 'A Cobra move exatamente 2 casas a menos que bloqueada por uma parede ou peça amiga',
    snakeMoveBlocks: 'Quando bloqueada por uma parede ou peça que não pode capturar, o movimento da Cobra é encurtado para 1 casa',
    snakeMoveBlocksPost: 'Ela ainda pode mover duas casas mesmo se houver uma peça intermediária',
    snakeStrike: 'A Cobra pode atacar 3 casas para frente se houver um animal inimigo',
    snakeStrikePost: 'Contanto que nenhuma peça intermediária bloqueie seu caminho',
    snakeShedskin: 'Uma vez por jogo, a Cobra pode trocar de pele e retornar à primeira fileira se a casa estiver livre',
    snakeShedskinPost: 'Este renascimento dá à Cobra uma vida extra cada jogo',

    // Tree
    treeMovement: 'A Árvore pode mover uma casa para frente ou para qualquer casa em sua fileira de lado a lado',
    treeMovementPost: 'Contanto que seu caminho não esteja bloqueado',
    treeHouse: 'A Árvore pode abrigar outras peças, protegendo-as de inimigos que não podem escalar Árvores. Talvez peças possam escalar como o Urso, Grou, Sapo, Fungo, Cabra, Macaco, Polvo e Cobra',
    treeHousePost: 'Quando uma peça que pode escalar uma árvore ataca, ela só captura a peça abrigada, protegendo a Árvore',
    treeTrample: 'A Árvore como o Rinoceronte, captura todas as peças em uma casa quando se move',
    treeTramplePost: 'Isso inclui uma Cabra desmaiada',
    treePlant: 'A Árvore é uma planta, não um animal, então é imune a vários efeitos',
    treePlantPost: 'Como veneno, zumbificação, enredamento e infecção por vírus!',

    // Virus
    virusMovement: 'O Vírus só pode mover para casas ocupadas com animais, que estão duas casas de distância',
    virusMoveBlocks: 'O Vírus pode mover apenas uma casa se estiver ao lado de uma parede',
    virusCaptureHost: 'Quando o Vírus pousa em (dentro de) qualquer peça animal, ele apenas as infecta, elas ainda podem continuar jogando normalmente enquanto infectadas',
    virusCaptureHostPost: 'O Vírus só captura a peça quando sai do hospedeiro infectado',
    virusContagion: 'O Vírus pode se espalhar rapidamente infectando múltiplos hospedeiros em um único turno',
    virusContagionPost: 'Contágio permite ao Vírus fazer tantos movimentos legais quanto quiser cada turno',

    // Wolf
    wolfMovement: 'O Lobo pode mover em forma de L, como o cavalo no xadrez',
    wolfMovementPost: 'Ele não é obstruído por nenhuma outra peça',
    wolfLoneWolf: 'Lobo',
    wolfLoneWolfPost: 'O Lobo também se considera solitário quando ainda tem uma Cabra desmaiada ou um aliado vírus',
  },

  // Tutorials
  tutorials: {
    dragToExploreMobile: '👆 Arraste para explorar • Belisque para zoom',
    dragToExploreDesktop: '🖱️ Arraste para explorar • Role para zoom',
    previousConstellation: 'Previous constellation',
    nextConstellation: 'Next constellation',
    lockedNextHint: 'Complete at least 3 {constellation} tutorials to move to the next constellation',
    lockedStateLabel: 'Star Path',
    freeStateLabel: 'Free Roam',
    clickToFreeRoam: 'Click to free roam',
    clickForStarPath: 'Click for Star Path',
    // Tutorial popups
    failed: 'FAILED!',
    success: 'SUCCESS!',
    failedDefaultMessage: "Don't give up! Try a different approach.",
    superMessage: 'Perfect! You achieved Super completion!',
    passMessage: 'Well done! Tutorial completed!',
    tryAgain: 'Try Again',
    back: 'Voltar',
    next: 'Próximo',
    backToDev: 'Back to Dev',
    backToTutorials: 'Back to Tutorials',
    continue: 'Continue',
    close: 'Close',
  },

  // Sandbox
  sandbox: {
    title: 'CAIXA DE AREIA',
    description: 'Experimente e Pratique',
    mode: 'Modo:',
    modeValue: 'Caixa de Areia',
    status: 'Status:',
    statusReady: 'Pronto',
    clearBoard: 'Limpar Tabuleiro',
  },

  // Multiplayer
  multiplayer: {
    title: 'MULTIJOGADOR',
    description: 'Encontre sua partida e compita!',
    // Rematch
    rematchRequest: 'Rematch Request',
    rematchMessage: '{opponent} wants to play again!',

    // Placement matches
    placementMatches: 'Partidas de Colocação',
    matchProgress: 'Progresso da Partida',
    gamesCompleted: '{games} / 10 Jogos Completados',
    estimatedFinalRating: 'Classificação Final Estimada',
    startingRating: 'Classificação inicial',
    matchesRemaining: '{matches} partidas restantes',
    findPlacementMatch: 'Encontrar Partida de Colocação',

    // Matchmaking modes
    findMatch: 'Encontrar Partida',
    competitive: 'Competitivo',
    competitiveDesc: 'Encontre oponentes próximos ao seu ranking',
    quick: 'Rápido',
    quickDesc: 'Encontre partidas competitivas rapidamente',
    casual: 'Casual',
    casualDesc: 'Sem ranking - jogue por diversão!',
    placement: 'Posicionamento',
    placementDesc: 'Complete 10 partidas para obter um ranking',
    startSearch: 'Iniciar Busca',

    // Searching
    searching: 'Procurando...',
    mode: 'Modo:',
    inQueue: 'Na Fila:',
    players: 'jogador',
    playersPlural: 'jogadores',
    cancelSearch: 'Cancelar Busca',

    // Game info
    status: 'Status:',
    ready: 'Pronto',
    selectingKing: 'Selecionando Rei',
    placingPieces: 'Colocando Peças',
    playing: 'Jogando',
    gameType: 'Tipo de Jogo:',
    opponent: 'Oponente:',
    opponentElo: 'ELO do Oponente:',
    unranked: 'Sem Ranking',

    // Piece placement
    dragPieces: 'Arraste peças para o tabuleiro',
    lightPieces: 'Peças Claras (Você)',
    darkPieces: 'Peças Escuras (Você)',

    // Waiting states
    waitingForOpponent: 'Aguardando Oponente...',
    waitingForKing: 'Aguardando oponente selecionar seu rei...',

    // Warnings
    invalidPlacement: 'Colocação Inválida',
    lightTurn: 'É a vez do jogador Claro!',
    darkTurn: 'É a vez do jogador Escuro!',
    onlyLightPieces: 'Você só pode colocar peças claras!',
    onlyDarkPieces: 'Você só pode colocar peças escuras!',
    mustPlaceOnRow: 'Peças {color} devem ser colocadas na fileira {row}!',

    // Chat
    chat: 'Chat',
    typeMessage: 'Digite uma mensagem...',
    send: 'Enviar',
  },

  // Main Page
  mainPage: {
    title: 'XADREZ ANIMAL',
    subtitle: 'Um jogo para humanos',
    playersOnline: 'Jogadores online atualmente',
    placement: 'Colocação',
    placementProgress: 'Colocação',
    challengeAI: 'Desafiar IA',
    multiplayer: 'Multijogador',
    sandbox: 'Caixa de Areia',
    tutorials: 'Tutoriais',
    shop: 'Loja',
    collection: 'Coleção',
    history: 'Histórico',
    analytics: 'Análises',
    courses: 'Cursos',
    upgradeAccount: 'Atualizar conta',
    signIn: 'Entrar',
    playAsGuest: 'Jogar como Convidado',
    welcomeBack: 'Bem-vindo de volta! Você geralmente joga como',

    // Learn the Pieces section
    learnThePieces: 'Aprenda as peças',

    // Learn the Rules section
    learnTheRules: 'Aprenda as Regras',
    premiseTitle: 'Premissa',
    premiseText: 'Zodiac é uma alternativa ao xadrez com um rei OCULTO de um elenco de 13 peças, selecione um elenco único e então blefe seu oponente para derrotá-lo em um tabuleiro 5 por 8',
    selectionTitle: 'Seleção',
    selectionText: 'Para iniciar um jogo, escolha secretamente seu rei, então coloque suas 5 peças alternadamente com seu oponente para criar um de mais de 500 bilhões de estados iniciais.',
    objectiveTitle: 'Objetivo',
    objectiveText: 'Ou leia seu oponente para CAPTURAR seu rei secreto ou CORRA com seu rei através do tabuleiro para garantir a vitória!',
    competeTitle: 'Competir',
    competeText: 'Teste suas habilidades na classificação, desenvolva novas técnicas e estratégias pessoais, suba de rank para enfrentar os melhores!',
    fullRulesButton: 'Para regras oficiais completas clique aqui',

    // FAQ section
    faqTitle: 'Perguntas Frequentes',
    faqQuestion1: 'Qual é a ideia por trás do xadrez Zodiac?',
    faqAnswer1: 'O xadrez Zodiac foi inspirado inicialmente por palavras de Bobby Fischer sobre sua inspiração para criar o Chess960, queríamos expandir a ideia de combater a memorização mecânica e celebrar a intuição humana em profundidade insondável!',
    faqQuestion2: 'Por que precisamos de uma alternativa ao xadrez',
    faqAnswer2: 'Não precisamos! Zodiac não quer desviar pessoas de jogar xadrez! É uma opção diferente com seus próprios pontos fortes e fracos, esperamos que você se divirta com ele e nos ajude a adaptar este jogo para animar jogadas inovadoras',
    faqQuestion3: 'Como você vence no Xadrez Zodiac?',
    faqAnswer3: 'Existem três formas de vencer: capturar a peça rei oculta do seu oponente, correr com seu próprio rei para o lado oposto do tabuleiro, ou em uma partida com controles de tempo, ter o tempo do seu oponente esgotado',
    faqQuestion4: 'Isto é um FAQ?',
    faqAnswer4: 'Sim, você pode olhar qualquer uma das perguntas listadas no FAQ e se quiser mais detalhes, pode clicar nas perguntas e então ler os detalhes seguintes, como estes detalhes que você está lendo agora',
    faqQuestion5: 'Quanto tempo dura um jogo típico?',
    faqAnswer5: 'Cada jogo difere muito! Alguns jogos acabam em 2 movimentos e alguns podem levar 30 minutos, nós geralmente tendemos a encontrá-los na marca de 5-15 minutos!',
    faqQuestion6: 'O que acontece se ninguém puder fazer um movimento legal?',
    faqAnswer6: 'Se um jogador não puder fazer nenhum movimento legal (empate), o jogo termina em empate. O jogo também pode terminar em empate através de repetição (mesmo estado do tabuleiro 3 vezes) ou por acordo mútuo entre os jogadores!',

    // About section
    aboutButton: 'Sobre',
    privacyPolicy: 'Política de Privacidade',
    developerInterface: 'Interface do Desenvolvedor',
  },

  // About Modal
  about: {
    title: 'Sobre Zodiac',
    paragraph1: 'Zodiac é um jogo de tabuleiro semelhante ao xadrez combinando elementos de seleção de peças de jogos como LoL e DotA, com mecânicas de blefe de pôquer ou jogos de dedução social.',
    paragraph2: 'Versões iniciais do jogo foram criadas em 2014, sob o nome Shadow Chess. Em 2018 foi redesenhado para ser o que você vê hoje, envolvendo um elenco de peças divertidas com padrões de movimento e habilidades equilibrados, mas únicos.',
    paragraph3: 'Nossa visão é gravar todos os dados de jogo do usuário para continuar a evoluir o jogo em um esforço para manter a jogabilidade refrescante, encorajando jogadas inovadoras.',
    paragraph4: 'Com o espaço de busca gigante de Zodiac, informação oculta e posições de tabuleiro de abertura, esperamos evitar o domínio da IA e manter zodiac um jogo para humanos!',
  },

  // Privacy Policy
  privacy: {
    title: 'Política de Privacidade',
    lastUpdated: 'Última Atualização',

    introduction: {
      title: 'Introdução',
      p1: 'Bem-vindo ao Zodiac Chess ("nós", "nosso" ou "nos"). Estamos comprometidos em proteger sua privacidade e garantir que você tenha uma experiência de jogo segura e agradável. Esta Política de Privacidade explica como coletamos, usamos, divulgamos e protegemos suas informações quando você usa nosso site e jogo.',
      p2: 'Ao usar o Zodiac Chess, você concorda com a coleta e uso de informações de acordo com esta política. Se você não concorda com nossas políticas e práticas, por favor não use nosso serviço.',
      contact: 'Entre em contato conosco em:',
    },

    infoCollect: {
      title: 'Informações que Coletamos',
      accountInfo: {
        title: '1. Informações da Conta',
        item1: 'Endereço de E-mail: Necessário para criação de conta e comunicação',
        item2: 'Nome de Usuário: Seu nome de exibição escolhido',
        item3: 'Senha: Criptografada e armazenada com segurança',
      },
      gameData: {
        title: '2. Dados do Jogo',
        item1: 'Estatísticas do Jogo: Vitórias, derrotas, classificação ELO, progresso de partidas de colocação',
        item2: 'Dados de Jogabilidade: Seleções de peças, movimentos feitos, estratégias usadas',
        item3: 'Histórico de Partidas: Registros de jogos jogados, oponentes enfrentados',
        item4: 'Compras no Jogo: Itens cosméticos e status de assinatura premium',
      },
      technicalData: {
        title: '3. Dados Técnicos',
        item1: 'Informações do Dispositivo: Tipo de navegador, sistema operacional',
        item2: 'Dados de Uso: Páginas visitadas, tempo gasto, recursos usados',
        item3: 'Armazenamento Local: Preferências de idioma, configurações de UI, estado temporário do jogo',
      },
    },

    children: {
      title: 'Privacidade de Crianças (Conformidade COPPA)',
      p1: 'Zodiac Chess foi projetado para ser adequado para toda a família e adequado para jogadores de todas as idades, incluindo crianças. Tomamos cuidado especial para cumprir com a Lei de Proteção à Privacidade Online de Crianças (COPPA).',
      p2: 'Para usuários com menos de 13 anos de idade: Recomendamos que crianças usem nosso modo de jogo como convidado, que não requer criação de conta ou coleta de dados. Contas de convidado não têm acesso a recursos de chat de texto, garantindo que crianças não sejam expostas à comunicação com a internet mais ampla. Se uma criança criar uma conta, exigimos consentimento dos pais antes de coletar qualquer informação pessoal.',
      p3: 'NÃO coletamos, usamos ou compartilhamos intencionalmente informações pessoais de crianças menores de 13 anos sem consentimento verificado dos pais.',
      p4: 'Segurança do Chat: O chat de texto é automaticamente desativado para todas as contas de convidado/temporárias. Titulares de contas padrão têm a opção de desativar a funcionalidade de chat nas configurações de sua conta a qualquer momento.',
      parentalRights: 'Os pais têm o direito de:',
      right1: 'Revisar as informações pessoais de seus filhos',
      right2: 'Solicitar exclusão dos dados de seus filhos',
      right3: 'Recusar coleta ou uso adicional das informações de seus filhos',
      contactUs: 'Para exercer estes direitos ou se você acredita que seu filho nos forneceu informações pessoais, por favor entre em contato conosco imediatamente em contact@zodiac-chess.com',
    },

    howWeUse: {
      title: 'Como Usamos Suas Informações',
      item1: 'Fornecer e melhorar nossos serviços de jogo',
      item2: 'Combinar você com oponentes apropriados baseado no nível de habilidade',
      item3: 'Rastrear seu progresso, estatísticas e conquistas',
      item4: 'Processar pagamentos por assinaturas premium e itens cosméticos',
      item5: 'Enviar anúncios e atualizações importantes do serviço',
      item6: 'Analisar dados de jogo para melhorar o equilíbrio do jogo e recursos',
    },

    thirdParty: {
      title: 'Serviços de Terceiros',
      firebase: {
        title: 'Firebase (Google)',
        description: 'Usamos Firebase para autenticação, armazenamento de banco de dados e funcionalidade multijogador. Firebase pode coletar certos dados conforme descrito em sua política de privacidade.',
      },
      stripe: {
        title: 'Stripe',
        description: 'Usamos Stripe para processar pagamentos por assinaturas premium e compras no aplicativo. Stripe lida com todas as informações de cartão de pagamento - nunca vemos ou armazenamos seus detalhes de pagamento completos.',
      },
      netlify: {
        title: 'Netlify',
        description: 'Nosso site está hospedado no Netlify, que pode coletar dados padrão de hospedagem web como endereços IP e logs de acesso.',
      },
      adsense: {
        title: 'Google AdSense (Futuro)',
        description: 'Podemos exibir anúncios através do Google AdSense. Estes anúncios podem usar cookies para personalização. Para conteúdo direcionado a crianças, mostraremos apenas anúncios não personalizados em conformidade com COPPA.',
      },
      viewPolicy: 'Ver sua Política de Privacidade',
    },

    cookies: {
      title: 'Cookies e Armazenamento Local',
      description: 'Usamos armazenamento local do navegador (similar a cookies) para melhorar sua experiência:',
      item1: 'Preferência de Idioma: Lembrar seu idioma selecionado',
      item2: 'Sessão da Conta: Mantê-lo conectado (funciona com Firebase)',
      item3: 'Configurações do Jogo: Lembrar suas preferências de UI e configurações de caixa de areia',
      item4: 'Cookies de Publicidade: Se você consentir, serviços de anúncios de terceiros podem usar cookies para personalização de anúncios',
    },

    security: {
      title: 'Segurança de Dados',
      p1: 'Implementamos medidas de segurança apropriadas para proteger suas informações:',
      item1: 'Criptografia de Senha: Todas as senhas são criptografadas usando métodos padrão da indústria',
      item2: 'Conexões Seguras: Criptografia HTTPS para toda transmissão de dados',
      item3: 'Regras de Segurança do Firebase: Controles estritos de acesso ao banco de dados',
      p2: 'No entanto, nenhum método de transmissão pela internet é 100% seguro. Embora nos esforcemos para proteger seus dados, não podemos garantir segurança absoluta.',
    },

    retention: {
      title: 'Retenção de Dados',
      p1: 'Retemos seus dados da seguinte forma:',
      item1: 'Contas Ativas: Dados são retidos enquanto sua conta está ativa',
      item2: 'Contas Inativas: Se sua conta estiver inativa por 10 anos, podemos excluir seus dados',
    },

    rights: {
      title: 'Seus Direitos de Privacidade',
      description: 'Dependendo de sua localização, você pode ter os seguintes direitos:',
      access: {
        title: 'Acesso:',
        description: 'Solicitar uma cópia de seus dados pessoais',
      },
      correction: {
        title: 'Correção:',
        description: 'Solicitar correções aos seus dados',
      },
      deletion: {
        title: 'Exclusão:',
        description: 'Solicitar exclusão de sua conta e dados',
      },
      portability: {
        title: 'Portabilidade de Dados:',
        description: 'Solicitar seus dados em um formato portátil',
      },
      optOut: {
        title: 'Opt-Out:',
        description: 'Optar por não receber comunicações de marketing',
      },
      contact: 'Para exercer qualquer um destes direitos, por favor entre em contato conosco em contact@zodiac-chess.com',
    },

    international: {
      title: 'Usuários Internacionais',
      p1: 'Zodiac Chess é operado da Nova Zelândia. Se você está acessando nosso serviço de fora da Nova Zelândia, esteja ciente de que suas informações podem ser transferidas para, armazenadas e processadas na Nova Zelândia e outros países onde nossos provedores de serviço operam.',
      p2: 'Ao usar nosso serviço, você consente com a transferência de suas informações para países fora do seu país de residência, que podem ter leis de proteção de dados diferentes.',
    },

    changes: {
      title: 'Alterações a Esta Política de Privacidade',
      description: 'Podemos atualizar esta Política de Privacidade de tempos em tempos. Notificaremos você de quaisquer alterações publicando a nova Política de Privacidade nesta página e atualizando a data de "Última Atualização". Alterações significativas serão comunicadas através de e-mail ou um aviso proeminente em nosso site.',
    },

    contact: {
      title: 'Entre em Contato Conosco',
      description: 'Se você tiver quaisquer perguntas, preocupações ou solicitações em relação a esta Política de Privacidade ou nossas práticas de dados, por favor entre em contato conosco:',
      email: 'E-mail:',
      company: 'Empresa:',
    },

    cookieConsent: {
      title: 'Cookie Consent & Control',
      p1: 'We believe in transparency and giving you control over your data. When you first visit Zodiac Chess, you will be presented with a cookie consent banner that allows you to choose which types of cookies you want to accept.',
      categories: {
        title: 'Cookie Categories',
        necessary: {
          title: 'Necessary Cookies',
          description: ' These cookies are essential for the website to function properly. They enable core features like authentication, game state management, and security. You cannot opt out of these cookies.',
        },
        analytics: {
          title: 'Analytics Cookies',
          description: ' These cookies help us understand how visitors interact with our website by collecting anonymous usage data through Firebase Analytics. This helps us improve the game experience.',
        },
        advertising: {
          title: 'Advertising Cookies',
          description: ' These cookies are used by Google AdSense to display personalized advertisements. Premium members never see ads, regardless of consent settings.',
        },
      },
      control: {
        title: 'How to Control Cookies',
        p1: 'You have several options to manage your cookie preferences:',
        method1: 'Cookie Banner: On your first visit, you can accept all cookies, reject optional cookies, or customize your preferences.',
        method2: 'Browser Settings: Most browsers allow you to refuse or delete cookies through their settings menu.',
        method3: 'Opt-Out Links: For advertising cookies, you can opt out of personalized ads using the links below.',
      },
      optOut: {
        title: 'Opt Out of Personalized Advertising',
        p1: 'If you would like to opt out of personalized advertising from Google and other ad networks, you can use these resources:',
        googleAds: 'Google Ad Settings - Manage Google personalized ads',
        daa: 'Digital Advertising Alliance (DAA) - Opt out of interest-based ads',
        eaa: 'European Interactive Digital Advertising Alliance (EDAA) - EU users opt-out',
      },
      moreInfo: 'For more detailed information about the cookies we use, please visit our',
      cookiePolicyLink: 'Cookie Policy',
    },
  },

  // Cookie Consent Banner
  cookieConsentBanner: {
    title: 'We Value Your Privacy',
    description: 'We use cookies to enhance your experience, analyze site usage, and show personalized ads (for free users only). You can customize your preferences at any time.',
    acceptAll: 'Accept All',
    rejectAll: 'Reject Optional',
    customize: 'Customize',
    savePreferences: 'Save Preferences',
    back: 'Back',
    necessary: 'Necessary Cookies',
    necessaryDesc: 'Required for the site to function. These cannot be disabled.',
    analytics: 'Analytics Cookies',
    analyticsDesc: 'Help us understand how you use the site to improve your experience.',
    advertising: 'Advertising Cookies',
    advertisingDesc: 'Used to show personalized ads (free users only, premium members never see ads).',
    privacyPolicy: 'Privacy Policy',
    cookiePolicy: 'Cookie Policy',
  },

  // Terms of Service
  terms: {
    title: 'Termos de Serviço',
    lastUpdated: 'Última Atualização',
    back: 'Voltar',
    viewPrivacyPolicy: 'Ver Política de Privacidade',
    acknowledgment: 'Ao usar o Zodiac Chess, você reconhece que leu, compreendeu e concorda em estar vinculado a estes Termos de Serviço.',
    acceptance: {
      title: '1. Aceitação dos Termos',
      p1: 'Ao acessar e usar o Zodiac Chess (o "Serviço"), você aceita e concorda em estar vinculado a estes Termos de Serviço. Se você não concordar com estes termos, por favor não use o Serviço.',
      p2: 'Reservamo-nos o direito de modificar estes termos a qualquer momento. O uso contínuo do Serviço após as alterações constitui aceitação dos termos modificados.',
    },
    description: {
      title: '2. Descrição do Serviço',
      p1: 'Zodiac Chess é um jogo de tabuleiro estratégico online com peças de animais únicas com habilidades especiais. O Serviço inclui:',
      feature1: 'Jogabilidade single-player contra oponentes de IA',
      feature2: 'Matchmaking multiplayer e jogo competitivo',
      feature3: 'Tutoriais interativos e recursos de aprendizagem',
      feature4: 'Criação de conta e rastreamento de progresso',
      feature5: 'Recursos opcionais de assinatura premium',
      feature6: 'Opções de personalização cosmética',
    },
    accounts: {
      title: '3. Contas de Usuário',
      eligibility: {
        title: '3.1 Elegibilidade',
        p1: 'Você deve ter pelo menos 13 anos para criar uma conta. Usuários menores de 13 anos podem usar o modo de jogo como convidado com supervisão dos pais, mas não podem criar contas.',
      },
      responsibilities: {
        title: '3.2 Segurança da Conta',
        p1: 'Você é responsável por:',
        item1: 'Manter a confidencialidade da sua senha',
        item2: 'Todas as atividades que ocorrem sob sua conta',
        item3: 'Notificar-nos imediatamente de qualquer uso não autorizado',
        p2: 'Não somos responsáveis por qualquer perda ou dano decorrente de acesso não autorizado à conta.',
      },
      prohibited: {
        title: '3.3 Atividades Proibidas',
        p1: 'Você NÃO pode:',
        item1: 'Compartilhar sua conta com outros',
        item2: 'Usar múltiplas contas para manipular rankings',
        item3: 'Usar bots, scripts ou ferramentas automatizadas para jogar',
        item4: 'Assediar, abusar ou ameaçar outros jogadores',
        item5: 'Explorar bugs ou falhas para vantagem injusta',
        item6: 'Fazer engenharia reversa ou tentar acessar nosso código-fonte',
        p2: 'A violação dessas regras pode resultar em suspensão da conta ou banimento permanente.',
      },
    },
    premium: {
      title: '4. Assinaturas Premium',
      billing: {
        title: '4.1 Cobrança',
        p1: 'As assinaturas premium são processadas através do Stripe. Ao comprar uma assinatura premium, você nos autoriza a cobrar seu método de pagamento de forma recorrente até que você cancele.',
        p2: 'As taxas de assinatura são:',
        item1: 'Plano Mensal: Cobrado mensalmente no aniversário da sua data de compra',
        item2: 'Plano Anual: Cobrado anualmente no aniversário da sua data de compra',
        p3: 'Os preços estão sujeitos a alterações com aviso prévio de 30 dias aos assinantes ativos.',
      },
      cancellation: {
        title: '4.2 Cancelamento',
        p1: 'Você pode cancelar sua assinatura a qualquer momento através das configurações da sua conta ou entrando em contato com o suporte. O cancelamento entra em vigor no final do seu período de cobrança atual.',
        p2: 'Você manterá os recursos premium até o final do seu período pago, mesmo após o cancelamento.',
      },
      refunds: {
        title: '4.3 Reembolsos',
        p1: 'Assinaturas mensais: Sem reembolsos por meses parciais. Cancele a qualquer momento para interromper cobranças futuras.',
        p2: 'Assinaturas anuais: Reembolso total se solicitado dentro de 7 dias da compra. Após 7 dias, os reembolsos ficam a nosso critério.',
        p3: 'Compras cosméticas: Geralmente não reembolsáveis. Entre em contato com o suporte para circunstâncias excepcionais.',
      },
    },
    acceptable: {
      title: '5. Política de Uso Aceitável',
      p1: 'Você concorda em usar o Zodiac Chess de maneira respeitosa e legal. Condutas proibidas incluem:',
      item1: 'Trapacear, hackear ou explorar mecânicas do jogo',
      item2: 'Assédio, discurso de ódio ou linguagem discriminatória',
      item3: 'Spam, publicidade ou solicitação',
      item4: 'Compartilhar conteúdo inapropriado (se chat ou conteúdo gerado pelo usuário estiver habilitado)',
      item5: 'Personificar outros usuários ou membros da equipe',
      item6: 'Tentar interromper ou danificar o Serviço',
      p2: 'Reservamo-nos o direito de investigar violações e tomar as medidas apropriadas, incluindo encerramento de conta e denúncia às autoridades, se necessário.',
    },
    intellectual: {
      title: '6. Direitos de Propriedade Intelectual',
      ownership: {
        title: '6.1 Nosso Conteúdo',
        p1: 'Todo o conteúdo do jogo, incluindo, mas não limitado a, mecânicas de jogo, arte, animações, efeitos sonoros, código e design, são de propriedade da Animal Chess Limited ou de nossos licenciadores.',
        p2: 'Você recebe uma licença limitada, não exclusiva e intransferível para usar o Serviço apenas para fins de entretenimento pessoal.',
      },
      userContent: {
        title: '6.2 Conteúdo do Usuário',
        p1: 'Ao enviar conteúdo (como mensagens de chat, nomes de usuário ou informações de perfil), você nos concede uma licença mundial e livre de royalties para usar, exibir e distribuir esse conteúdo em conexão com o Serviço.',
        p2: 'Você declara que possui ou tem os direitos necessários sobre qualquer conteúdo que enviar.',
      },
    },
    disclaimers: {
      title: '7. Isenções de Responsabilidade e Limitações',
      p1: 'O SERVIÇO É FORNECIDO "COMO ESTÁ" SEM GARANTIAS DE QUALQUER TIPO, EXPRESSAS OU IMPLÍCITAS.',
      p2: 'Não garantimos que:',
      item1: 'O Serviço será ininterrupto ou livre de erros',
      item2: 'Defeitos serão corrigidos',
      item3: 'O Serviço está livre de vírus ou componentes prejudiciais',
      item4: 'Os resultados do uso do Serviço atenderão às suas expectativas',
      p3: 'NA MÁXIMA EXTENSÃO PERMITIDA POR LEI, NÃO SOMOS RESPONSÁVEIS POR:',
      item5: 'Quaisquer danos indiretos, incidentais ou consequenciais',
      item6: 'Perda de lucros, dados ou reputação',
      item7: 'Interrupções de serviço ou perda de dados',
      item8: 'Danos que excedam o valor que você nos pagou nos últimos 12 meses',
    },
    privacy: {
      title: '8. Privacidade',
      p1: 'O uso do Serviço também é regido pela nossa Política de Privacidade, que explica como coletamos, usamos e protegemos suas informações pessoais.',
      p2: 'Ao usar o Serviço, você consente com nossas práticas de dados conforme descrito na Política de Privacidade.',
    },
    changes: {
      title: '9. Alterações nos Termos',
      p1: 'Reservamo-nos o direito de modificar estes Termos de Serviço a qualquer momento. Notificaremos os usuários sobre alterações materiais através de:',
      item1: 'Notificação por e-mail para usuários registrados',
      item2: 'Aviso destacado no site',
      item3: 'Data de "Última Atualização" atualizada no topo desta página',
      p2: 'O uso contínuo do Serviço após as alterações constitui aceitação dos termos modificados.',
    },
    governing: {
      title: '10. Lei Aplicável',
      p1: 'Estes Termos de Serviço são regidos pelas leis da Nova Zelândia, independentemente dos princípios de conflito de leis.',
      p2: 'Quaisquer disputas decorrentes destes termos ou do uso do Serviço serão resolvidas nos tribunais da Nova Zelândia.',
    },
    contact: {
      title: '11. Informações de Contato',
      p1: 'Para perguntas, preocupações ou suporte relacionado a estes Termos de Serviço:',
      email: 'E-mail:',
      company: 'Empresa:',
      address: 'Endereço:',
    },
    severability: {
      title: '12. Divisibilidade',
      p1: 'Se qualquer disposição destes termos for considerada inexequível ou inválida, essa disposição será limitada ou eliminada na medida mínima necessária, e as demais disposições permanecerão em pleno vigor e efeito.',
    },
  },

  // Cookie Policy
  cookiePolicy: {
    title: 'Política de Cookies',
    lastUpdated: 'Última Atualização',
    browserInstructions: {
      chrome: 'Configurações → Privacidade e Segurança → Cookies',
      firefox: 'Configurações → Privacidade e Segurança → Cookies e Dados do Site',
      safari: 'Preferências → Privacidade → Cookies e dados de sites',
      edge: 'Configurações → Privacidade, pesquisa e serviços → Cookies',
    },
    cookieTable: {
      name: 'Nome do Cookie',
      purpose: 'Finalidade',
      duration: 'Duração',
      type: 'Tipo',
    },
    relatedPolicies: {
      title: 'Políticas Relacionadas',
      description: 'Para mais informações sobre como tratamos seus dados, consulte:',
      privacy: 'Política de Privacidade',
      terms: 'Termos de Serviço',
    },

    introduction: {
      title: 'Introdução',
      p1: 'Esta Política de Cookies explica como o Zodiac Chess ("nós" ou "nosso") usa cookies e tecnologias semelhantes quando você visita nosso site.',
      p2: 'Ao usar nosso site, você consente com nosso uso de cookies de acordo com esta política. Se você não concordar, desative os cookies nas configurações do seu navegador ou não use nosso site.',
    },
    what: {
      title: 'O Que São Cookies?',
      p1: 'Cookies são pequenos arquivos de texto que são colocados no seu dispositivo (computador, smartphone, tablet) quando você visita um site. Eles são amplamente usados para fazer os sites funcionarem de forma eficiente e fornecer informações aos proprietários do site.',
      p2: 'Os cookies servem a vários propósitos, incluindo lembrar suas preferências, analisar o uso do site e habilitar determinados recursos.',
    },
    types: {
      title: 'Tipos de Cookies que Usamos',
      necessary: {
        title: '1. Cookies Necessários',
        description: 'Esses cookies são essenciais para o funcionamento adequado do site. Sem esses cookies, os serviços que você solicitou não podem ser fornecidos.',
        examples: 'Exemplos:',
        item1: 'Cookies de autenticação - Mantêm você conectado à sua conta',
        item2: 'Cookies de segurança - Protegem contra atividades fraudulentas',
        item3: 'Cookies de sessão - Mantêm o estado do seu jogo durante uma sessão',
        item4: 'Preferências de consentimento de cookies - Lembram suas escolhas de cookies',
      },
      analytics: {
        title: '2. Cookies de Análise',
        description: 'Esses cookies nos ajudam a entender como os visitantes interagem com nosso site, coletando informações anônimas sobre visitas às páginas, tempo gasto e recursos usados.',
        provider: 'Provedor: Firebase Analytics (Google)',
        purpose: 'Finalidade:',
        item1: 'Medir o tráfego do site e o engajamento do usuário',
        item2: 'Identificar recursos e páginas populares',
        item3: 'Entender a demografia dos usuários (faixa etária, localização geral)',
        item4: 'Melhorar o desempenho do site e a experiência do usuário',
      },
      advertising: {
        title: '3. Cookies de Publicidade',
        description: 'Esses cookies são usados para exibir anúncios relevantes para você. Eles também limitam o número de vezes que você vê um anúncio e ajudam a medir a eficácia das campanhas publicitárias.',
        provider: 'Provedor: Google AdSense',
        purpose: 'Finalidade:',
        item1: 'Mostrar anúncios personalizados com base em seus interesses',
        item2: 'Medir o desempenho e o engajamento dos anúncios',
        item3: 'Evitar que o mesmo anúncio seja exibido muitas vezes',
        note: 'Nota: Assinantes Premium nunca veem anúncios, independentemente das configurações de cookies.',
      },
    },
    firstThird: {
      title: 'Cookies Próprios vs Cookies de Terceiros',
      firstParty: {
        title: 'Cookies Próprios',
        description: 'Esses são cookies definidos diretamente pelo Zodiac Chess. Nós os usamos para funcionalidades essenciais do site, autenticação e para lembrar suas preferências.',
      },
      thirdParty: {
        title: 'Cookies de Terceiros',
        description: 'Esses são cookies definidos por serviços externos que usamos, como Google Analytics e Google AdSense. Os cookies de terceiros estão sujeitos às políticas de privacidade desses provedores.',
      },
    },
    specific: {
      title: 'Cookies Específicos que Usamos',
      tableHeader: 'Abaixo está uma lista detalhada dos cookies usados em nosso site:',
    },
    control: {
      title: 'Como Controlar Cookies',
      consent: {
        title: '1. Banner de Consentimento de Cookies',
        description: 'Quando você visitar nosso site pela primeira vez, verá um banner de consentimento de cookies. Você pode:',
        item1: 'Aceitar Todos - Permitir todos os cookies (necessários, análise e publicidade)',
        item2: 'Rejeitar Opcionais - Permitir apenas cookies necessários (sem análise ou anúncios)',
        item3: 'Personalizar - Escolher exatamente quais tipos de cookies você deseja permitir',
      },
      browser: {
        title: '2. Configurações do Navegador',
        description: 'A maioria dos navegadores permite que você controle os cookies através de suas configurações. Você pode:',
        item1: 'Bloquear todos os cookies',
        item2: 'Aceitar apenas cookies próprios',
        item3: 'Excluir cookies após cada sessão de navegação',
        item4: 'Visualizar e excluir cookies individuais',
        links: 'Aqui estão links para gerenciamento de cookies em navegadores populares:',
      },
      optOut: {
        title: '3. Ferramentas de Opt-Out',
        description: 'Para cookies de publicidade especificamente, você pode optar por não receber anúncios personalizados:',
        googleLink: 'Configurações de Anúncios do Google',
        googleDesc: ' - Gerenciar anúncios personalizados do Google',
        daaLink: 'Digital Advertising Alliance (DAA)',
        daaDesc: ' - Opt-out de publicidade baseada em interesses',
        edaaLink: 'European Interactive Digital Advertising Alliance (EDAA)',
        edaaDesc: ' - Ferramenta de opt-out específica para UE',
      },
    },
    impact: {
      title: 'Impacto de Desativar Cookies',
      p1: 'Se você desativar ou recusar cookies, observe que:',
      item1: 'Algumas partes do site podem não funcionar corretamente',
      item2: 'Você pode precisar reinserir suas preferências a cada visita',
      item3: 'Você pode ser desconectado da sua conta',
      item4: 'Cookies necessários são obrigatórios para o funcionamento do site - desativá-los impedirá você de usar recursos essenciais',
    },
    updates: {
      title: 'Atualizações desta Política de Cookies',
      p1: 'Podemos atualizar esta Política de Cookies periodicamente para refletir mudanças em nossas práticas ou por razões legais, regulatórias ou operacionais.',
      p2: 'Notificaremos você sobre mudanças significativas atualizando a data de "Última Atualização" no topo desta página. Por favor, revise esta política periodicamente.',
    },
    contact: {
      title: 'Entre em Contato',
      p1: 'Se você tiver dúvidas sobre nosso uso de cookies ou esta Política de Cookies, entre em contato conosco:',
      email: 'E-mail:',
      company: 'Empresa:',
    },
  },

  // Game
  game: {
    yourTurn: 'Sua Vez',
    opponentTurn: 'Vez do Oponente',
    victory: 'Vitória!',
    defeat: 'Derrota',
    draw: 'Empate',
    resign: 'Desistir',
    offerDraw: 'Oferecer Empate',
  },

  // Game Info
  gameInfo: {
    title: 'Game Info',
    sandboxMode: 'Sandbox Mode',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
    yourTurn: 'Your turn',
    opponentTurn: "Opponent's turn",
    aiThinking: 'AI thinking...',

    // Selection states
    selecting: 'Selecting {piece}',
    observing: 'Observing {piece}',
    selectingZombified: 'Selecting zombified enemy {piece}',
    selectionLocked: 'Selection locked on {piece}',
    selectionLockedPenguin: 'Pinguim',

    // Hints
    clickToFaint: 'Click on {piece} to faint',
    clickToRotate: 'Click on the {piece} to rotate',
    clickToInk: 'Click on the {piece} to ink',
    zombifiedWarning: '⚠️ While zombified, {piece} rotates before moving!',

    // Monkey bonus turn
    monkeySwing: 'Monkey completed swing, please move your Monkey to complete bonus turn',
    monkeyConsume: 'Monkey consumed fungi, please move your Monkey to complete bonus turn',

    // Virus bonus turn
    virusInfecting: 'Virus is infecting, continue turn or click on virus to end turn',

    // Penguin bonus turn
    penguinRotate: 'Penguin completed slide - please choose final rotation direction',
    penguinCaptureRotate: 'Penguin completed capture - please choose final rotation direction',
    penguinZombified: 'Zombified Penguin rotated - complete turn with slide/capture (zombification will end)',

    // Capture restrictions
    cannotCapture: '{piece} cannot capture: {targets}',
    cannotInfect: '{piece} cannot infect: {targets}',
    cannotEntangle: '{piece} cannot entangle: {targets}',
    monkeyBearRoll: '{piece} must roll 5-6 to capture enemy {target}',
    cannotBeCapturedBy: '{piece} cannot be captured by: {attackers}',
    monkeyNeedsRoll: '{attacker} needs to roll 5-6 to capture',

    // Meadow warning (Tree immobilization)
    meadowWarning: '{piece} is immobilized by enemy {fungi}',
    rhinoChargeWarning: '{piece} charge does not affect: {targets}',
    snakeStrikeWarning: '{piece} strike does not affect: {targets}',
  },

  // Piece names
  pieces: {
    Bear: 'Urso',
    Crane: 'Garça',
    Frog: 'Sapo',
    Fungi: 'Cogumelo',
    Goat: 'Cabra',
    Monkey: 'Macaco',
    Octopus: 'Polvo',
    Penguin: 'Pinguim',
    Rhino: 'Rinoceronte',
    Snake: 'Cobra',
    Tree: 'Árvore',
    Virus: 'Vírus',
    Wolf: 'Lobo',
  },

  // Short poetic vibe descriptions for landing carousel — one per variant
  pieceVibes: {
    Bear:    { light: 'Few dare approach',                   dark: 'Nothing impedes her hunger' },
    Crane:   { light: 'Sailing above, quieter than the wind',      dark: 'It circles. It waits. The lonely never return home' },
    Frog:    { light: 'Lazing on the lily pad',       dark: 'Take the colors as a warning' },
    Fungi:   { light: 'The meadow-maker',         dark: 'Consume and see who has been consumed' },
    Goat:    { light: 'Catch me on the cliff side',   dark: 'The corpse that blinks' },
    Monkey:  { light: 'Branch to branch to foe, laughing all the way',               dark: 'Roll the bones. Smiles either way' },
    Octopus: { light: 'Soft arms, razor sharp hooks, never releasing its grip',  dark: 'A bloom of black water. The shape inside is gone' },
    Penguin: { light: 'A harmless little thing in a tiny black coat',        dark: 'Slow and cute, right?' },
    Rhino:   { light: 'Waiting to face down a challenger', dark: 'Lock eyes at your peril' },
    Snake:   { light: 'Changing endings like outfits',                               dark: 'Do not tread near me' },
    Tree:    { light: 'A haven amongst the beasts',             dark: 'Standing where the dead stood. Still standing' },
    Virus:   { light: 'The battle for pandoras box',         dark: 'They feel triumph, then a cough, then silent disbelief' },
    Wolf:    { light: 'The alpha of his pack',  dark: 'When the pack is gone. What remains excites' },
  },


  // Move Context (piece descriptions)
  moveContext: {
    title: 'Move Context',
    emptyState: 'Select an ability from the left panel to view detailed information.',
  },

  // Challenge AI
  challengeAI: {
    // Title and tagline
    title: 'AI ARENA',
    tagline: 'Pick an AI to Battle or watch AI duke it out!',

    // Player labels
    lightPlayer: 'Light Player',
    darkPlayer: 'Dark Player',
    humanPlayer: 'Human Player',
    aiPlayer: 'AI',
    difficulty: 'Difficulty',
    difficultyEasy: 'Easy',
    difficultyMedium: 'Medium',
    difficultyHard: 'Hard',

    // AI Models
    aiGaia: 'Gaia',
    aiSentinel: 'Sentinel',
    aiAlchemist: 'Alchemist',
    aiZenith: 'Zenith',
    aiTrapper: 'Trapper',
    aiHunter: 'Hunter',
    aiWisp: 'Wisp',
    aiCreature: 'Creature',
    aiWeaver: 'Weaver',

    // Time Frames
    timeFast: 'Fast',
    timeStandard: 'Standard',
    timeDeep: 'Deep',

    // Thinking time
    thinkingTime: 'Thinking Time',

    // Info box
    matchupLabel: 'Matchup:',
    statusLabel: 'Status:',
    statusPaused: 'PAUSED',
    statusAIThinking: 'AI Thinking...',
    statusInGame: 'In Game',
    statusReady: 'Ready',
    matchupLocal2P: 'Local 2P',
    matchupPlayerVs: 'Player vs',
    matchupVsPlayer: 'vs Player',

    // Buttons
    startButton: 'Start',
    startRandomButton: 'Start Random',
    newGameButton: 'New Game',
    resumeButton: 'Resume',
    pauseButton: 'Pause',
    pauseQueuedButton: 'Pause (queued...)',
    viewKingsButton: 'View Kings',
    hideKingsButton: 'Hide Kings',
    viewKingsQueuedButton: 'View Kings (queued...)',
    hideKingsQueuedButton: 'Hide Kings (queued...)',
    homeButton: 'Home',
    toggleKingVisibility: 'Toggle king visibility',

    // Warning modal
    invalidPlacement: 'Invalid Placement',
    okButton: 'OK',
    warningLightTurn: "It's Light player's turn to place a piece!",
    warningDarkTurn: "It's Dark player's turn to place a piece!",
    warningLightRow: 'Light pieces must be placed on row 0 (your home row)!',
    warningDarkRow: 'Dark pieces must be placed on row 7 (your home row)!',
    warningOccupied: 'This square is already occupied! Choose an empty square.',
    warningKingRequired: 'You must place your king ({kingType}) before placing your 5th piece!',

    // Piece selection
    dragPieces: 'Drag pieces to the board',
    lightPieces: 'Light Pieces',
    darkPieces: 'Dark Pieces',

    // Mobile
    selectYourKing: 'Select Your King',
    selectPieceToPlace: 'Select Piece to Place',
    moveHistory: 'Move History',
    historyButton: 'History',
    backButton: 'Back',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
  },

  // Donation
  donation: {
    title: 'Support Zodiac Chess',
    supportDevelopment: 'Support Development',
    story1: "Hi! Your support helps me continue improving this unique game! Adding new features, maintaining servers, and keeping Zodiac Chess free for the community.",
    story2: "Even a small donation makes a huge difference and keeps this project alive. Thank you for being part of the Zodiac Chess journey :)",
    selectAmount: 'Choose Amount',
    customAmount: 'Or enter custom amount:',
    total: 'Total:',
    donateButton: 'Donate Now',
    processing: 'Processing...',
    disclaimer: 'Donations support development and server costs. Thank you for your generosity!',
    invalidAmount: 'Please enter a valid amount greater than $0',
    error: 'There was an error processing your donation. Please try again.',
  },

  // Game End Popup
  gameEnd: {
    victory: 'VICTORY!',
    defeat: 'DEFEAT!',
    draw: 'DRAW!',
    wonBy: 'Won by {condition}',
    lostBy: 'Lost by {condition}',
    drawBy: 'Draw by {condition}',
    youCapturedTheirKing: 'You captured their {piece} King!',
    yourKingWasCaptured: 'Your {piece} King was captured!',
    rematchButton: 'Rematch',
    backButton: 'Back',
    conditions: {
      kingslayer: 'Kingslayer',
      race: 'Race Victory',
      timeout: 'Timeout',
      threefold: '3x Repetition',
      noMoves: 'No Valid Moves',
      draw: 'Draw',
    },
  },

  // Upgrade Modal
  upgrade: {
    title: 'Upgrade to Premium',
    accountRequired: 'You need to create a permanent account before upgrading to premium.',
    createAccountPrompt: 'Create an account to save your progress and unlock premium features!',
    subtitle: 'Unlock powerful features to enhance your Zodiac Chess experience!',
    features: {
      history: 'Account History',
      historyItem1: 'Store and recall all your previous games',
      historyItem2: 'Replay your old games from anypoint to evaluate strategy',
      historyItem3: 'Use deep analytics to analyse board positions and brilliant move opportunities',
      analytics: 'Analytics',
      analyticsItem1: 'Get access to game stats',
      analyticsItem2: 'Analyse users piece and king selection across tonnes of metrics',
      analyticsItem3: 'Find out what metas are popular and whats working!',
      course: 'Course',
      courseItem1: 'Get access to upto date courses to develop your skill',
      courseItem2: "Learn meta's and concepts from the pro's",
      courseItem3: 'Get tips on your own game play to analyse your own weaknesses',
    },
    createAccount: 'Create Account',
    upgradeNow: 'Upgrade Now',
    cancel: 'Cancel',
  },

  // Premium Modal
  premium: {
    title: 'Premium Feature',
    accessDenied: 'Sorry you do not have a premium account, you do not have access to these features yet!',
  },

  // Stripe Error Page
  stripe: {
    errorTitle: 'Oops! Something Went Wrong',
    errorMessage: "We encountered an issue processing your payment. Don't worry, you haven't been charged.",
    whatHappened: 'What happened?',
    notCompleted: "Your payment wasn't completed. This could be due to:",
    reasons: {
      cancelled: 'Payment was cancelled',
      declined: 'Card was declined',
      connection: 'Connection issue during checkout',
      expired: 'Session expired',
    },
    whatToDo: 'What can you do?',
    actions: {
      tryDifferentCard: 'Try again with a different card',
      tryDifferentCardDesc: 'Use another payment method',
      retryPayment: 'Retry the payment',
      retryPaymentDesc: 'Sometimes a simple retry works',
      checkBank: 'Check with your bank',
      checkBankDesc: 'Ensure your card has sufficient funds',
    },
    tryAgain: 'Try Upgrading Again',
    returnHome: 'Return to Main Page',
    contactSupport: 'Need help? Contact support at support@zodiac-chess.com',
  },


  // How To Play - Learn the Pieces
  howToPlay: {
    // Section titles
    whatIsZodiac: 'What is it about?',
    gameSetup: 'Game Setup',
    basicRules: 'Basic Rules',
    backButton: 'BACK',
    homeButton: 'Home',
    fullRules: 'Full Rules',

    // What is Zodiac section
    whatIs: {
      p1: 'Zodiac is a two player abstract strategy game based off of Chess, Poker and DotA.',
      p2: 'It was created in 2014 as a crude version of itself called "Shadow Chess" based off its central principal of a secret king',
      p3: 'Later in 2018 it was redesigned to involve a roster of novel pieces with unique movement patterns and abilities',
      p4: "Zodiac's goal is to celebrate human intuition and novel play. To drive success toward a players ability to bluff and adapt to unfamiliar situations and create a nuanced set of challenges for the ever growing strength of AI",
      p5: "Another goal of Zodiac is to be a game for humans! With a very large search space for play, hidden information, win obfuscation and a changing roster of pieces over time. Zodiac wants to be a player data driven game that keeps creativity mainstay and staves off AI dominance",
      p6: 'We hope you stick around and see where this journey takes us',
    },

    // Setup section
    setup: {
      p1: "Players play a zodiac version of paper, scissors, rock to see who goes first!",
      p2: 'From there, select a piece to be your "King" your opponent won\'t know which one you have chosen.',
      p3: 'Then pick 5 pieces to play with, they all have different abilities, cohesion, strengths and weaknesses!',
      p4: 'Once you are both done the game will begin.',
      p5: 'Simply click on a piece to see where it can move to or click on any unhighlighted square to deselect the piece.',
      p6: 'Good luck!',
    },

    // Basic Rules section
    rules: {
      intro: 'The game of Zodiac is played by two players on a rectangle board made up of 40 squares (5 by 8).',
      toWinTitle: 'To win:',
      toWin1: 'Capture the opponents King',
      toWin2: '"Race" your King across the board',
      toWin3: 'Have your opponents timer expire',
      toWin4: 'Have your opponent surrender',
      drawTitle: 'A draw occurs',
      draw1: 'When a players king is still uncaptured and they cannot make any legal move, or;',
      draw2: 'The same board position is repeated three times',
    },

    // Piece tutorials
    tutorials: {
      bear: {
        desc1: 'Regular movement - The Bear can move one square in any direction',
        desc2: 'The Bear\'s ability "Savage" allows it to capture any piece regardless of defensive abilities',
        desc3: 'The bear is a "large" piece and a "predator" piece meaning many of the other Zodiacs cannot capture it!',
      },
      crane: {
        desc1: 'The Crane can move 1 or 2 in any straight line for its regular movement',
        desc2: "The Crane cannot capture any 'large' or 'predator' pieces",
      },
      frog: {
        desc1: 'The frog can jump 2 on diagonals for its regular movement, even over other pieces!',
        desc2: "If the frog's regular movement is blocked by a wall or a piece it cannot capture, its regular movement is shortened to 1 square diagonally",
        desc3: "If the frog has yet to make a move in the game, it is on its 'lily pad' and can move to any of the first 3 ranks as a defensive movement",
        desc4: 'If a piece captures a frog, it becomes poisoned and cannot make any move for its next available turn',
        desc5: "The frogs special movement is 'wall climb' if a frog is beside the edge of the board, it can also move one up or down",
      },
      fungi: {
        desc1: 'The Fungi can move one in any direction for its regular movement',
        desc2: "The fungi's ability 'meadow' prevents a tree from moving if it is within one square of the fungi and does not allow a tree to move within one square of the enemy fungi",
        desc3: "When captured the fungi applies a 'zombie' effect to any animal piece that captured it",
        desc4: 'While zombified, the fungi controls the piece for the following turn and acts as the piece, meaning if the fungi was your king, you can still win by race victory or capturing the enemy king within that round',
      },
      goat: {
        desc1: 'The goat can move one in any direction for its regular movement',
        desc2: "The goats ability 'traverse' allows it to hop across linked pieces and then move, it cannot capture any piece on a traverse",
        desc3: "The goat cannot capture any 'predators'",
        desc4: "The goat can use a special ability called 'faint' to make itself appear dead",
        desc5: "While fainted, the goat is unable to be captured by most pieces but cannot move if another piece is 'standing' on it (on the same square)",
      },
      monkey: {
        desc1: 'The monkey can move one in any direction for its regular movement',
        desc2: "The monkey can 'leap' over friendly and enemy pieces like a checkers piece if the formation allows it",
        desc3: 'If the monkey does leap over an enemy piece it must roll a dice to not be captured! One danger point per enemy piece it leaps in a single line',
        desc4: 'The monkey CAN capture a bear if it decides to gamble to attack it, on a 1-4 roll on a six sided dice, the Monkey is captured, on a 5 or 6, the Monkey captures the bear',
        desc5: "The monkey has two abilities - 'swing' and 'consume' on a swing (a leap ending over a tree) the monkey gains an extra movement, on a consume of any fungi, the monkey also gains one extra movement before its turns end",
      },
      octopus: {
        desc1: 'The octopus can move one in any direction for its regular movement',
        desc2: 'The octopus may only capture on orthagonal squares',
        desc3: "The octopus can use its ability 'entangle' on any animal piece on diagonal squares",
        desc4: 'The octopus may make any move AND entangle in one turn',
        desc5: "The octopus has an ability called 'ink' with this ability it can move to any orthagonal square and place 'shadows' on the other 3 orthagonal squares if they are not occupied or off of the board. To the opponent for the round following the 'ink' ability the shadows and real octopus are indistinguishable",
      },
      penguin: {
        desc1: "The penguin has an ability called 'rotate' it is the only piece that has a set direction and may use the 'rotate' move to redirect its direction for its turn",
        desc2: "For the penguins regular movement 'slide' it must move to the furthest point in the direction it is facing and once there, it may use a rotate before its turns end to redirect its direction",
        desc3: "The penguin cannot capture any 'large' or 'predator' pieces. It can capture any other piece within one square of itself and use a rotate ability after the capture",
      },
      rhino: {
        desc1: "The rhino can move 'back left', 'back right' or two forward as part of its regular movement",
        desc2: "The rhino has an ability called 'trample' where captures ALL pieces in the path of its movement",
        desc3: 'Once per game a rhino may perform a charge of 3 squares ahead if any animal is present in any of the 3 squares directly infront of the rhino',
        desc4: 'The rhino has a special ability called "rhino defence" where the rhino cannot be captured from \'the front\'',
        desc5: "The rhino has an ability called 'lane' where if it has not moved and the friendly piece directly to its left or right has not moved, it can switch places with that piece for its turn",
      },
      snake: {
        desc1: 'The snake can move 2 squares only in orthagonal directions, including through other pieces for its regular movement',
        desc2: 'If its regular movement is blocked by a wall or a piece it cannot capture, its regular movement becomes 1',
        desc3: 'The snake has an ability called "strike" where if an animal is exactly 3 squares ahead of it and there are no pieces between, it can \'strike\' forward and capture that animal',
        desc4: 'The snake has an ability called "shed" where once per game if the snake is captured, it will return to the first rank of the board, in the same column, as if it had a second life. If the first rank is not a valid square for the snake to move to, it is permanently captured',
      },
      tree: {
        desc1: 'The tree may move one forward or unlimitedly side to side if not blocked by any other piece',
        desc2: "The tree has a special ability called 'house' where any piece that can 'climb' tree's may sit on top of the tree piece. If an enemy piece attacks a tree with a housed piece, the housed piece is captured and the tree houses the enemy piece",
        desc3: 'When a piece is housed in the tree, if an enemy piece cannot climb the tree, both the tree and the housed piece are protected from capture',
      },
      wolf: {
        desc1: 'The wolf moves in an L shape like a knight in chess for its regular movement',
        desc2: "If the wolf is the last piece on the board* it's ability 'lone wolf' is activated and it moves in a long L instead as pictured above. *The wolf will enter lone if on a team with a fainted goat or infecting virus",
      },
      virus: {
        desc1: "The virus may move 2 squares in any straight line for its regular movement, it does not capture but uses its ability 'infect' to cause the piece to be infected rather than captured",
        desc2: "The virus can only move to any animal piece, if blocked by a wall, the virus's regular movement is only 1 square",
        desc3: "When an animal piece is 'infected' if the virus leaves the infected piece in to another piece, the piece it left is captured and the new piece is 'infected'",
        desc4: "The virus has an ability called 'infectious' which allows the virus to complete as many valid moves in one move as it likes, capturing multiple animals in one turn",
        desc5: "While not 'infecting' the virus can be captured like any other piece, if an animal captures an infected piece, it becomes infected",
      },
    },
  },
};
